import { render, staticRenderFns } from "./WebsiteMailers.vue?vue&type=template&id=95a1118e"
import script from "./WebsiteMailers.vue?vue&type=script&lang=js"
export * from "./WebsiteMailers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports